import { useHostListener } from '@/Pages/HostListeners/hooks/useHostListener';
import { Skeleton } from '@/components/Skeleton';
import { OrgConfigs, useOrgConfig } from '@/hooks/useOrgConfig';
import { HostProjectSchema } from '@/types/schema';

export function HostListenersDetails({
  hostProject,
}: {
  hostProject: HostProjectSchema;
}) {
  const { value: enableLgpListenersPage } = useOrgConfig(
    OrgConfigs.enable_lgp_listeners_page
  );

  const { data: listener, isLoading: isListenerLoading } = useHostListener(
    enableLgpListenersPage ? hostProject.host_listener_id : undefined
  );

  return isListenerLoading ? (
    <Skeleton className="h-[100px] w-full" />
  ) : listener && listener.compute_config.k8s_namespaces ? (
    <>
      <div className="flex flex-col items-start gap-1.5">
        <div className="whitespace-nowrap text-xs font-medium uppercase tracking-wide text-quaternary">
          Listener
        </div>
        <div>{listener.compute_id}</div>
      </div>
      <div className="flex flex-col items-start gap-1.5">
        <div className="whitespace-nowrap text-xs font-medium uppercase tracking-wide text-quaternary">
          Kubernetes Namespace
        </div>
        <div key={hostProject.metadata.k8s_namespace}>
          {hostProject.metadata.k8s_namespace}
        </div>
      </div>
    </>
  ) : null;
}
